import {Game} from "../Game";
import {gsap} from "gsap";
import {GameUtils} from "../utils/GameUtils";
import {WallClock} from "./WallClock";

export class Background extends PIXI.Container {
    private _spine: PIXI.spine.Spine
    private _level: number;
    private _spineHeight: number = 1680;
    private _wallClock:WallClock;

    get wallClock(): WallClock {
        return this._wallClock;
    }

    constructor(level: number, bgStr: string) {
        super();
        this._level = level;
        this.init(bgStr)
    }

    public playAnim(tag: string, isLoop: boolean = false) {
        this._spine.state.setAnimation(0, tag, isLoop);
    }

    public scaleTo(scale: number, duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this._spine.scale, {duration: duration, x: scale, y: scale}, 0);
        return tl;
    }

    public getCurrentAnimName():string{
        return this._spine.state.tracks[0].animation.name;
    }

    public stopAnim(): void {
        this._spine.state.clearTracks();
        this._spine.state.setEmptyAnimations(0);
        GameUtils.resetSpineItem(this._spine);
    }

    private init(bgStr: string): void {
        this.name = this._level + "";
        this.createSpine(bgStr);
        this.visible = false;
    }

    private createSpine(bgStr: string): void {
        this._spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset(bgStr));
        this._spine.name = bgStr;
        if (bgStr != "reception") {
            this._spine.state.setAnimation(0, "animation", false);
        }
        this._spine.position.set(360, 360 + (this._level * this._spineHeight * 0.7621));
        this._spine.scale.set(0.7621);

        if (bgStr === "mainGame") {
            this._wallClock = new WallClock();
            this._wallClock.scale.set(0.5);
            this._wallClock.position.set(0, -307);
            this._spine.addChild(this._wallClock);
        }
        this.addChild(this._spine);
    }
}